module.exports = __webpack_public_path__ + "img/sucot-2019-thumbnail.678ee58e.jpg";